export const hy = {
  title: 'PRODES (Իրավական Amazon)',
  subtitle: 'տարեկան, 6.25հա, Իրավական Amazon, INPE',
  content: [
    {
      label: 'Գործառույթ',
      value:
        'Բրազիլիայի օրինական Ամազոնի անտառահատումների մոնիտորինգի համակարգ, որն օգտագործվում է Բրազիլիայի կառավարության կողմից հանրային քաղաքականություն սահմանելու համար',
    },
    {
      label: 'Բանաձեւ',
      value: '6.25 հա',
    },
    {
      label: 'Աշխարհագրական ծածկույթ',
      value: 'Բրազիլիայի իրավական Amazon',
    },
    {
      label: 'Աղբյուր',
      value: 'INPE',
    },
    {
      label: 'Հաճախականություն',
      value: 'Տարեկան',
    },
    {
      label: 'Բովանդակության ամսաթիվը',
      value: '2008-2021 թթ',
    },
    {
      label: 'Զգուշացումներ',
      value:
        'PRODES-ը բացահայտում է միայն 6,25 հեկտար կամ ավելի մեծ տարածքի անտառների բացատները, ուստի անտառների դեգրադացիա կամ ավելի փոքր բացատներ հրդեհից կամ ընտրովի հատումներից չեն հայտնաբերվում: Ծածկույթի տարածքների հաճախակի ամպամածությունը կարող է փոխել անտառահատման հաշվետու տարին: Զեկուցված տարին վերլուծաբանների կողմից հայտնաբերված անտառահատումների առաջին տարին է, բայց դա պարտադիր չէ, որ համապատասխանի անտառահատման տարվան, եթե նախորդ տարիներին լանդշաֆտը ծածկված է եղել ամպերով:',
    },
    {
      label: 'Լիցենզիա',
      value: 'Creative Commons BY SA 3.0',
    },
  ],
  overview: {
    label: 'Ընդհանուր ակնարկ',
    value:
      'PRODES նախագիծը վերահսկում է բրազիլական Ամազոնի և Սերադոյի բիոմների հստակ հատումները և 1988 թվականից ի վեր տարածաշրջանի անտառահատումների տարեկան ցուցանիշներ է գրանցել: Բրազիլիայի կառավարությունն օգտագործում է այս թվերը՝ սահմանելու հանրային քաղաքականություն, ներառյալ Ամազոնի բիոմում վարկերի հասանելիությունը սահմանելու, անտառահատումների կրճատման նպատակներ սահմանելու և անտառահատումները նվազեցնելու համար միջոցներ հայթայթելու համար: PRODES-ը պատմականորեն օգտագործել է Landsat 5 պատկերները, բայց այժմ նաև ներառում է պատկերներ Landsat 7 և 8, CBERS-2, CBERS-2B, Resourcesat-1 և UK2-DMC-ից: PRODES-ը շահագործվում է Տիեզերական հետազոտությունների ազգային ինստիտուտի (INPE) կողմից՝ համագործակցելով Շրջակա միջավայրի նախարարության (MMA) և Բրազիլիայի Շրջակա միջավայրի և վերականգնվող բնական պաշարների ինստիտուտի (IBAMA) հետ: 2002 թվականից PRODES-ի բոլոր տվյալները հանրությանը հասանելի են առցանց: Բրազիլական Ամազոնն ու Սերադոն ծածկող Landsat-ի 220 հետքերից յուրաքանչյուրի համար մուտքագրված պատկերներն ընտրվում են՝ ելնելով դրանց ամպամածության բացակայության և նկարահանման ամսաթվից: PRODES համակարգն օգտագործում է սեզոնային տարին՝ սկսած օգոստոսի 1-ից, տարեկան անտառահատումները հաշվարկելու համար, ուստի նկարներն ընտրվում են հնարավորինս մոտ այս ամսաթվին (ընդհանուր առմամբ հուլիսին, օգոստոսից և սեպտեմբերից): 2003 թվականից մինչև 2005 թվականը վերլուծաբաններն օգտագործեցին պատկերի փոխակերպումը, որպեսզի որոշեն բուսականության, հողի և ստվերի բաղադրիչները SPRING ծրագրի միջոցով: Այս բաղադրիչները բաժանվել և դասակարգվել են անտառային, ոչ անտառային, նպատակային տարում անտառահատումների, նախորդ անտառահատումների, ամպերի և ջրի դասերի, որոնք այնուհետև ձեռքով ուղղվում են փորձագետների կողմից: Սկսած 2005թ.-ից, ներդրվեց նոր մեթոդաբանություն, որն օգտագործում է բաց կոդով TerraAmazon հարթակը: Պլատֆորմը թույլ է տալիս PRODES-ի վերլուծությունը ավելի միատեսակ լինել և կարող է ներառել տարբեր արբանյակների պատկերներ: Ինչպես նախկինում, պատկերներն ընտրված են հնարավորինս ամպից ազատ լինելու համար: Պատկերներն այնուհետև դիմակավորված են՝ բացառելու ոչ անտառային, նախորդ անտառահատումները և ջուրը՝ օգտագործելով նախորդ տարվա վերլուծությունը: Այնուհետև վերլուծաբանները գծագրում են նախորդ տարվա անձեռնմխելի անտառի անտառահատված բազմանկյունները: Տվյալների այս հավաքածուն ցույց է տալիս տարեկան անտառահատումները 2008-2020 թվականներին Նարազիլյան իրավական Ամազոնում:',
  },
  citation: {
    label: 'Մեջբերում',
    value:
      'Տիեզերական հետազոտությունների ազգային ինստիտուտ (INPE): «ՊՐՈԴՈՒՄ Է անտառահատումները»։ Հասանելի է Global Forest Watch-ի միջոցով [date]-ին: www.globalforestwatch.org',
  },
};
